/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a new claim status template
 * @export
 * @interface CreateClaimStatusTemplateRequest
 */
export interface CreateClaimStatusTemplateRequest {
    /**
     * ID of the pipeline this status belongs to
     * @type {number}
     * @memberof CreateClaimStatusTemplateRequest
     */
    pipelineId: number;
    /**
     * Name of the status
     * @type {string}
     * @memberof CreateClaimStatusTemplateRequest
     */
    displayName: string;
    /**
     * Order in which statuses should be displayed
     * @type {number}
     * @memberof CreateClaimStatusTemplateRequest
     */
    displayOrder?: number;
    /**
     * Optional color code for UI display
     * @type {string}
     * @memberof CreateClaimStatusTemplateRequest
     */
    color?: string | null;
    /**
     * Optional description of the status
     * @type {string}
     * @memberof CreateClaimStatusTemplateRequest
     */
    description?: string | null;
}

/**
 * Check if a given object implements the CreateClaimStatusTemplateRequest interface.
 */
export function instanceOfCreateClaimStatusTemplateRequest(value: object): value is CreateClaimStatusTemplateRequest {
    if (!('pipelineId' in value) || value['pipelineId'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    return true;
}

export function CreateClaimStatusTemplateRequestFromJSON(json: any): CreateClaimStatusTemplateRequest {
    return CreateClaimStatusTemplateRequestFromJSONTyped(json, false);
}

export function CreateClaimStatusTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClaimStatusTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'pipelineId': json['pipelineId'],
        'displayName': json['displayName'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'color': json['color'] == null ? undefined : json['color'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateClaimStatusTemplateRequestToJSON(json: any): CreateClaimStatusTemplateRequest {
    return CreateClaimStatusTemplateRequestToJSONTyped(json, false);
}

export function CreateClaimStatusTemplateRequestToJSONTyped(value?: CreateClaimStatusTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pipelineId': value['pipelineId'],
        'displayName': value['displayName'],
        'displayOrder': value['displayOrder'],
        'color': value['color'],
        'description': value['description'],
    };
}

